import { history } from 'store';
import { Route, useLocation } from 'react-router';
import React, { useMemo } from 'react';

import GATracking from 'components/GATracking/index';

export const pushTo = (route: string, state: any = {}) => () => {
  history.push({
    pathname: route,
    state,
  });
  GATracking.pageView();
};

export const renderMergedProps = (component: any, ...rest: any) => {
  const finalProps = Object.assign({}, ...rest);

  return React.createElement(component as any, finalProps);
};

export const routeHelper = { renderMergedProps };
//Pass props through Route component
export const PropsRoute = ({
  component,
  ...rest
}: {
  component?: any;
  rest?: any[];
}) => {
  return (
    <Route
      {...rest}
      render={routeProps => {
        return routeHelper.renderMergedProps(component, routeProps, rest);
      }}
    />
  );
};

export function useQuery() {
  const { search } = useLocation();

  return useMemo(() => new URLSearchParams(search), [search]);
}

const routesHelper = { pushTo };

export default routesHelper;
